import axios, { AxiosPromise } from 'axios';
import {
  IGetTutorClass,
  ITutorClassReq,
} from '../../models/tutor/tutorClass.model';

const uri = '/mgmt/tutor/classes';

export const getTutorClass = (
  params: ITutorClassReq,
): AxiosPromise<IGetTutorClass> => axios.get(uri, { params });
